<template>
  <ul class="booklist clearfix">
    <li :class="{ big: big }" v-for="(book, index) in booklist" :key="index">
      <template v-if="book.book">
        <dl>
          <dt>
            <a @click="goSeeDetail(book.book.id)">
              <img v-lazy="imgURL + book.book.iconUrl" :alt="book.book.name" />
            </a>
          </dt>
          <dd>
            <a @click="goSeeDetail(book.book.id)">
              <h4 :title="book.book.id">{{ book.book.name }}</h4>
            </a>
            <a @click="goSeeDetail(book.book.id)">
              <em class="author" v-if="book.book.author != undefined">{{
                book.book.author.name
              }}</em>
            </a>
          </dd>
        </dl>
      </template>

      <template v-else>
        <dl>
          <dt>
            <a @click="goSeeDetail(book.id)">
              <img v-lazy="imgURL + book.iconUrl" :alt="book.name" />
            </a>
          </dt>
          <dd>
            <a @click="goSeeDetail(book.id)">
              <h4 :title="book.id">{{ book.name }}</h4>
            </a>
            <a @click="goSeeDetail(book.id)">
              <em class="author" v-if="book.authot != undefined">{{
                book.author.name
              }}</em>
            </a>
          </dd>
        </dl>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    big: Boolean,
    booklist: Array
  },
  methods: {
    goSeeDetail(bookid) {
      this.$router.push(`/bookdetail/${bookid}`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.booklist
    padding-top 24px
    li
        float left
        margin 0 27px 30px 0
        width 140px
        &.big
            width 176px
            margin 0 28px 0px 0
            dl
                dt
                    height 258px
                    img
                        width 176px
                        height 236px
        &:nth-child(6n)
            margin-right 0px
        &:hover
            dl
                dt
                    transform translate3d(0, -3%, 0)
        dl
            dt
                transition all 0.17s ease-in-out
                -webkit-transform translateZ(0)
                -webkit-transition all 0.17s ease-in-out
                transform translateZ(0)
                height 200px
                img
                    width 140px
                    height 182px
                    box-shadow 0 5px 5px rgba(0, 0, 0, 0.35)
            dd
                h4
                    height 28px
                    line-height 28px
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden
                    font-size 16px
                    color #333
                    margin-bottom 6px
                    &:hover
                        color #48a2df
                .author
                    display block
                    white-space nowrap
                    font-size 13px
                    margin-bottom 12px
                    text-overflow ellipsis
                    overflow hidden
                    color #999
                    &:hover
                        color #707070
</style>
